import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { ToastContainer } from 'react-toastify'

const ToastPortal = () => {
  const [toastRoot, setToastRoot] = useState<HTMLElement | null>(null)

  useEffect(() => {
    const toastRootElement = document.createElement('div')
    toastRootElement.id = 'toast-root'
    toastRootElement.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      pointer-events: none;
      z-index: 9999;
    `

    document.body.appendChild(toastRootElement)

    setToastRoot(toastRootElement)

    return () => {
      if (document.body.contains(toastRootElement)) {
        document.body.removeChild(toastRootElement)
      }
    }
  }, [])

  if (!toastRoot) {
    return null
  }

  return createPortal(
    <ToastContainer
      position="top-right"
      autoClose={35000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      //enableMultiContainer={false}
      limit={50} // Maximum 5 toasts at once
      theme="light"
      // style={{
      // }}
      // Ensure complete isolation
      className="toast-container-portal"
      toastClassName="toast-portal"
    />,
    toastRoot
  )
}

export default ToastPortal